module.exports = __webpack_public_path__ + "img/Basicinformationdocumentsofthecompany.236d189f.jpg";